import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { ERoleAccess } from '@/enum';
import { createEncryptedStorage } from '@/utils/encryption';

export type TSection = {
  id: string;
  section_code: ERoleAccess;
  name: string;
  has_access: boolean;
};

export type TUser = {
  token?: string;
  id?: string;
  name: string;
  email: string;
  profile_image?: string;
  is_access: string;
  sections?: TSection[];
};

type TStore = {
  user: TUser;
  setUser: (_user: TUser) => void;
};

export const USER_INIT_STATE: TUser = {
  token: '',
  id: '',
  name: '',
  email: '',
  is_access: '',
  profile_image: '',
  sections: [],
};

const useUser = create<TStore>()(
  persist(
    (set) => ({
      user: USER_INIT_STATE,
      setUser: (user) => set({ user }),
    }),
    {
      name: 'supporting-properties',
      storage: createEncryptedStorage<TStore>(),
    }
  )
);

export default useUser;
